var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon for Nav Bar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M26 22.4883H35.6C37.8402 22.4883 38.9603 22.4883 39.816 22.9243C40.5686 23.3077 41.1805 23.9197 41.564 24.6723C42 25.528 42 26.6481 42 28.8883V42.4883M26 42.4883V12.8883C26 10.6481 26 9.52797 25.564 8.67232C25.1805 7.91967 24.5686 7.30775 23.816 6.92426C22.9603 6.48828 21.8402 6.48828 19.6 6.48828H12.4C10.1598 6.48828 9.03969 6.48828 8.18404 6.92426C7.43139 7.30775 6.81947 7.91967 6.43597 8.67232C6 9.52797 6 10.6481 6 12.8883V42.4883M44 42.4883H4M13 14.4883H19M13 22.4883H19M13 30.4883H19",
    stroke: "#6C737F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBuilding);
export default __webpack_public_path__ + "static/media/AddBuilding.5476c9be054eab077a38015bd7674a4e.svg";
export { ForwardRef as ReactComponent };